import { useEffect, useState } from "react";
import { style } from "./StyleType";
import { Step, StepIndicator, StepIndicatorWrapper, StepLabel, StepProgress, StepProgressBar, StepProgressLabel, StepsGroup } from "./Style";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import { ReactComponent as IconCheck } from "../../../assets/icons/check.svg";

interface TmpStepCustomProps {
    current: number;
    steps: any[];
}

export default function TmpStepCustom(props: TmpStepCustomProps) {

    const [responsive, setResponsive] = useState<boolean>();

    useEffect(() => {
      const handleResize = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return setResponsive(width < 768);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
    }, []);
  
    // Passing style props to styled component
    StepsGroup.defaultProps = style;
    Step.defaultProps = style;
    StepIndicatorWrapper.defaultProps = style;
    StepIndicator.defaultProps = style;
    StepLabel.defaultProps = style;
  
    StepProgress.defaultProps = style;
    StepProgressBar.defaultProps = style;
    StepProgressLabel.defaultProps = style;
  
    return responsive ? (
      <>
        <StepProgress>
          <StepProgressBar value={props.current} max={props.steps.length} />
          <StepProgressLabel>
            Etapa {props.current} de {props.steps.length}
          </StepProgressLabel>
        </StepProgress>
      </>
    ) : (
      <StepsGroup>
        {props.steps.map(({ label }, index) => {
          const type = props.current === index + 1 ? "current" : props.current > index ? "finished" : "disabled";  
          return (
            <Step type={type} key={index}>
              <StepIndicatorWrapper type={type}>
                <StepIndicator type={type}>
                  {type === "finished" ? (
                    <TmpIconCustom icon={<IconCheck />} size="sm" />
                  ) : (
                    index + 1
                  )}
                </StepIndicator>
              </StepIndicatorWrapper>
              <StepLabel type={type}>{label}</StepLabel>
            </Step>
          );
        })}
      </StepsGroup>
    );

}